export const FULFILLMENT_TYPES = {
  BUY_ONLINE_PICKUP_IN_STORE: 'BuyOnlinePickupInStore',
  SHIP_TO_HOME: 'ShipToHome',
  BUY_ONLINE_DELIVER_FROM_STORE: 'BuyOnlineDeliverFromStore',
  BUY_ONLINE_SHIP_TO_STORE: 'BuyOnlineShipToStore',
  WILL_CALL_FULFILLMENT: 'WillCallFulfillment',
  APPLIANCE: 'Appliance',
  MISC: 'MISC'
};

export const FULFILLMENT_STATUSES = {
  BEING_PROCESSED: 'Being Processed',
  SHIPPED: 'Shipped',
  OUT_FOR_DELIVERY: 'Out for Delivery',
  ON_ITS_WAY_TO_STORE: 'On its way to Store',
  READY_FOR_PICKUP: 'Ready for Pickup',
  ON_SCHEDULE: 'On Schedule',
  CANCELED: 'Canceled',
  RETURNED: 'Returned',
  DELIVERED: 'Delivered'
};

export const STATUS_CODES = {
  SEE_ORDER_DETAILS: 100,
  PROCESSING: 101,
  SHIPPED: 102,
  IN_TRANSIT: 103,
  ATTEMPTED: 104,
  DELIVERED: 105,
  BACKORDERED: 106,
  WORK_ORDER_CANCELED: 107,
  MAJOR_APPLIANCE_ON_SCHEDULE: 108,
  OUT_FOR_DELIVERY: 109,
  DELIVERY_ATTEMPTED: 110,
  BODFS_ON_SCHEDULE: 111,
  ON_ITS_WAY_TO_STORE: 130,
  READY_FOR_PICKUP: 131,
  PREPARING_FOR_PICKUP: 132,
  CANCELED: 140,
  RETURNED: 150,
  RETURN_IN_PROGRESS: 151,
  COMPLETED: 200,
  DFS_DELIVERED: 1000,
  DFS_ON_SCHEDULE: 401
};
